<template>
  <NoCustomerState v-if="!selectedCustomerId" :hasCustomers="hasCustomers" />
  <div v-else>
    <div class="tw-flex tw-flex-row tw-justify-between tw-px-4 tw-items-center tw-mb-4">
      <span class="tw-text-sm tw-font-semibold tw-text-secondary-500">
        {{ t('customer_management.titles.project_list') }}
      </span>
      <button
        @click="createProject"
        class="tw-text-sm tw-font-semibold tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      >
        {{ t('customer_management.actions.new_project') }}
      </button>
    </div>
    <ProjectsFancyTable :customerId="selectedCustomerId" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import ProjectsFancyTable from './Table/ProjectsFancyTable.vue';
import NoCustomerState from '@/components/shared/NoCustomerState.vue';
import router from '@/router';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';
import { useCustomerStore } from '@/stores/customer.store';

const { t } = useI18n();
const { setBreadcrumbs } = useBreadcrumbs();
const { hasCustomers, selectedCustomerId } = storeToRefs(useCustomerStore());

onMounted(() => {
  setBreadcrumbs([
    {
      labelKey: 'sidebar.items.projects',
    },
  ]);
});

const createProject = () => {
  router.push({ name: 'create-project' });
};
</script>
